import React from 'react'
import AppBackBtn from '../components/ui/AppBackBtn'
import AppWrapper from '../components/ui/AppWrapper/AppWrapper'
// import DebtPanel from '../components/ui/DebtPanel/DebtPanel'

class DebtView extends React.Component {
  render() {
    return (
      <>
        <AppBackBtn to="/home" />
        <AppWrapper className="bg-white h-80">
          {/*<DebtPanel />*/}
          <div>
            <div className="flow-root mt-6">
              <ul role="list" className="-my-5 divide-y divide-gray-200">
                <li className="py-5">
                  <div className="relative focus-within:ring-2 focus-within:ring-indigo-500">
                    <p className="text-sm font-normal text-black">Общая сумма за 2023 год</p>
                    <p className="text-base font-semibold text-010045">1000 руб.</p>
                    <p className="text-sm font-normal text-black mt-3">Задолженность</p>
                    <p className="text-base font-semibold text-BB0000">1000 руб.</p>
                    <p className="text-sm font-normal text-black mt-3">Уплачено</p>
                    <p className="text-base font-semibold text-010045">0 руб.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </AppWrapper>
      </>
    )
  }
}

export default DebtView
